<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      platformUrl: 'https://hy.djplus.cn', // https://hy.djplus.cn  https://dp.djplus.c/  http://192.168.2.224:8080
      themeList: [
        {
          name: '样式一',
          logo: require('imgs/partyTop/hy-logo2.png'),
          backImg: 'https://hypadinterface.djplus.cn/Image/mobile-back.png',
          pageBg: 'https://hypadinterface.djplus.cn/Image/mobile-bg.webp',
          mobileBorder: 'https://hypadinterface.djplus.cn/Image/mobile-border.webp',
          mobileShadow: 'https://hypadinterface.djplus.cn/Image/mobile-shadow.png'
        }, {
          name: '样式二',
          logo: require('imgs/partyTop/hy-logo3.png'),
          backImg: 'https://hypadinterface.djplus.cn/Image/mobile-back2.png',
          pageBg: 'https://hypadinterface.djplus.cn/Image/mobile-bg2.webp',
          mobileBorder: 'https://hypadinterface.djplus.cn/Image/mobile-border2.webp',
          mobileShadow: 'https://hypadinterface.djplus.cn/Image/mobile-shadow2.png'
        }, {
          name: '样式三',
          logo: require('imgs/partyTop/hy-logo4.png'),
          backImg: 'https://hypadinterface.djplus.cn/Image/mobile-back3.png',
          pageBg: 'https://hypadinterface.djplus.cn/Image/mobile-bg3.webp',
          mobileBorder: 'https://hypadinterface.djplus.cn/Image/mobile-border3.webp',
          mobileShadow: 'https://hypadinterface.djplus.cn/Image/mobile-shadow3.png'
        }
      ],
      curTheme: '样式一',
      t: 0 // 1:隐藏返回上级
    }
  },
  computed: {
    ...mapGetters({
      navList: 'config/getNavList',
      currentPageTitle: 'config/getCurrentPageTitle'
    }),
    curThemeObj() {
      return this.themeList.filter(item => item.name === this.curTheme)[0]
    }
  },
  created() {
    const { t = 0 } = this.$route.query
    this.t = Number(t || 0)
  },
  methods: {
    onReturn() {
      window.location.href = 'https://hyadmin.djplus.cn/hyPartyBuildEntry'
    },
    toIndex() {
      const home = this.navList?.find(item => item.templateName === this.currentPageTitle)?.path || '/'
      this.$router.replace(home)
      // this.$router.push('/communityIntro')
    },
    handleCheckTheme({ name }, i) {
      this.curTheme = name
    }
  }
}
</script>

<template>
  <div
    class="mobile-index-container"
    :style="{backgroundImage: `url(${curThemeObj.pageBg})`, backgroundSize: '100% 100%'}"
  >
    <img
      :src="curThemeObj.logo"
      class="hy-logo2-img"
      :class="{'hy-logo2-img-2': curThemeObj.name === '样式二', 'hy-logo2-img-3': curThemeObj.name === '样式三'}"
    >
    <img v-if="curThemeObj.name === '样式三'" :src="require('imgs/partyTop/hy-logo4-2.png')" class="hy-logo4-2">
    <div
      class="mobile-iframe-shadow"
      :class="{'mobile-iframe-shadow-2': curThemeObj.name === '样式二', 'mobile-iframe-shadow-3': curThemeObj.name === '样式三'}"
      :style="{backgroundImage: `url(${curThemeObj.mobileShadow})`, backgroundSize: '100% 100%'}"
    >
      <div
        class="mobile-iframe-box"
        :class="{'mobile-iframe-box-2': curThemeObj.name === '样式二', 'mobile-iframe-box-3': curThemeObj.name === '样式三'}"
        :style="{backgroundImage: `url(${curThemeObj.mobileBorder})`, backgroundSize: '100% 100%'}"
      >
        <iframe class="mobile-iframe" :src="platformUrl" /><!-- scrolling="auto" -->
      </div>
    </div>
    <img
      v-if="t === 0"
      :src="curThemeObj.backImg"
      class="mobile-back-img pointer"
      :class="{'mobile-back-img-o': curThemeObj.name === '样式一'}"
      @click="toIndex"
    >
    <p v-else class="return-text pointer" @click="onReturn">返回</p>
    <p class="corp" :class="{'corp-w': curThemeObj.name !== '样式一', 'corp-3': curThemeObj.name === '样式三'}">
      <span>主办：中共洪雅组织部</span>
      <span>技术支持：成都集思创科技有限公司</span>
    </p>
    <div class="theme-tab-box">
      <p
        v-for="(v, i) in themeList"
        :key="v.name"
        class="pointer"
        :class="{'theme-item--active': v.name === curTheme}"
        @click="handleCheckTheme(v, i)"
      >{{ v.name }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-index-container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  .return-text {
    position: absolute;
    left: 0;
    bottom: 15px;
    color: #999;
    font-size: 18px;
  }
  .hy-logo2-img {
    position: absolute;
    top: 42px;
    left: 45px;
    width: 97px;
    height: 56px;
  }
  .hy-logo4-2 {
    position: absolute;
    top: 42px;
    right: 45px;
    width: 97px;
    height: 56px;
  }
  .hy-logo2-img-2 {
    width: 254px;
    height: 56px;
  }
  .hy-logo2-img-3 {
    width: 220px;
    height: 56px;
  }
  .mobile-iframe-shadow {
    padding: 53px 40px 14px;
    margin-top: 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }
  .mobile-iframe-shadow-2 {
    padding: 28px 44px 58px;
  }
  .mobile-iframe-shadow-3 {
    padding: 22px 37px 52px;
  }
  .mobile-iframe-box {
    padding: 7px 12px;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    .mobile-iframe {
      width: 432px;
      height: 900px;
      border-radius: 28px;
    }
  }
  .mobile-iframe-box-2 {
    padding: 0;
  }
  .mobile-iframe-box-3 {
    padding: 7px;
  }
  .mobile-back-img {
    position: absolute;
    bottom: 0;
    width: 132px;
    height: 52px;
  }
  .mobile-back-img-o {
    bottom: 20px;
  }
  .corp {
    position: absolute;
    left: 50px;
    bottom: 44px;
    font-size: 18px;
    color: #77B39F;
    display: flex;
    align-items: center;
    column-gap: 36px;
  }
  .corp-w {
    color: #fff;
  }
  .corp-3 {
    bottom: 30px;
  }
  .theme-tab-box {
    position: absolute;
    right: 20px;
    bottom: 54px;
    color: #999;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    .theme-item--active {
      color: #666;
    }
  }
}
</style>
